import { render, staticRenderFns } from "./TenantFormDialog.vue?vue&type=template&id=2d302972&scoped=true&"
import script from "./TenantFormDialog.vue?vue&type=script&lang=js&"
export * from "./TenantFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./TenantFormDialog.vue?vue&type=style&index=0&id=2d302972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d302972",
  null
  
)

export default component.exports